import { EventInput } from '@fullcalendar/core';
import CalendarEvents from './calendar-events.json';

export const INITIAL_EVENTS: EventInput[] = CalendarEvents.map((event: any) => {
    return {
        id: event.id,
        title: event.title,
        start: event.startDate,
        extendedProps: {
            id: event.id,
            title: event.title,
            startDate: event.startDate,
            endDate: event.endDate,
            startTime: event.startTime,
            endTime: event.endTime,
        },
    };
});
